import { NgFor, NgIf } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { AbstractControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatCard, MatCardContent, MatCardActions } from '@angular/material/card';
import { MatDivider } from '@angular/material/divider';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatSelect, MatOption } from '@angular/material/select';
import { MatSlider, MatSliderThumb } from '@angular/material/slider';
import { CartLine } from '@next/core-lib/cart';
import { AgrI18nSharedModule } from '@next/core-lib/i18n';
import { Store, select } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SiloProductItem } from 'src/app/components/silos/models/silo-product-list.models';
import { LineItem } from 'src/app/product/models/product.models';

import { GetVariant } from '../../../models/product-delivery.models';
import * as ProductSelectors from '../../../store/selectors';

@Component({
  selector: 'app-product-supplement-item',
  templateUrl: './product-supplement-item.component.html',
  styleUrls: ['./product-supplement-item.component.scss'],
  imports: [
    MatCard,
    FormsModule,
    ReactiveFormsModule,
    MatCardContent,
    MatFormField,
    MatLabel,
    MatSelect,
    NgFor,
    MatOption,
    NgIf,
    MatSlider,
    MatSliderThumb,
    MatDivider,
    MatCardActions,
    MatButton,
    AgrI18nSharedModule,
  ],
})
export class ProductSupplementItemComponent implements OnInit, OnDestroy {
  @Input() entry: AbstractControl;
  @Input() index: number;
  @Input() selectedSkuLine: LineItem;

  @Output()
  removeSupplementEvent = new EventEmitter<number>();
  @Output() disableAddEvent = new EventEmitter<boolean>();
  availableVariants: GetVariant[] = [];

  public variants$: Observable<GetVariant[]> = this.store.pipe(select(ProductSelectors.selectVariants));

  public selectedCartLine$: Observable<CartLine> = this.store.select(ProductSelectors.selectSelectedCartLine);

  public selectedSiloProduct$: Observable<SiloProductItem> = this.store.select(ProductSelectors.selectSelectedProductSiloLine);

  private destroy$: Subject<void> = new Subject<void>();

  constructor(private readonly store: Store) {}

  ngOnInit(): void {
    this.variants$.pipe(takeUntil(this.destroy$)).subscribe((variants) => {
      const selectedSupplement = (this.entry as FormGroup).controls['supplement'].value as GetVariant;
      this.availableVariants = variants.filter((v) => !this.selectedSkuLine.productSupplements?.map((ps) => ps.description).includes(v.description));
      if (selectedSupplement !== null && !this.availableVariants?.find((v) => v.description === selectedSupplement?.description)) {
        this.disableAddEvent.emit(this.availableVariants.length === 0);
        this.availableVariants.push(selectedSupplement);
      }
      this.availableVariants.sort((a, b) => a.description.localeCompare(b.description));
    });
  }

  public formatLabel(value: number): string {
    return `${value}%`;
  }

  public compareSupplement(s1: GetVariant, s2: GetVariant): boolean {
    return s1 && s2 ? JSON.stringify(s1) === JSON.stringify(s2) : s1 === s2;
  }

  public removeEntry(index: number): void {
    this.removeSupplementEvent.emit(index);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
